import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '../fi-dialogs/fi-dialogs-content-base';
import { AppTextService } from '../app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Component({
    selector: 'fi-confirm-user-delete-dialog',
    template: `
        <p class="delete-user-dialog-text">{{ getDescriptionText() }}</p>
        <p class="warning-text delete-user-dialog-text">
            {{ getDialogTextTransferOwnershipTextStart() }}
            <span class="action-text" (click)="handleTransferOwnershipClick()">
                {{ 'user.single_delete_confirm_dialog_message_transfer_ownership' | fiAppText }}
            </span>
            {{ getDialogTextTransferOwnershipTextEnd() }}
        </p>
        <p class="delete-user-dialog-text">{{ getConfirmDeleteText() }}</p>

        <mat-form-field appearance="outline" class="BorderRedInput">
            <mat-label>{{ 'common.type_here' | fiAppText }}</mat-label>
            <input matInput [(ngModel)]="confirmText" />
        </mat-form-field>
    `,
    styleUrl: './fi-confirm-user-delete-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-confirm-user-delete-dialog' },
    standalone: false,
})
export class FiConfirmUserDeleteDialogComponent
    extends FiDialogsContentBase<{ userId: number; isMultipleUsersDelete: boolean }, void>
    implements OnInit
{
    confirmText: string;

    ngOnInit() {
        this.setServices();
    }

    handleTransferOwnershipClick() {
        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.OtherSettings.TransferOwnership)) {
            this.navigateToTransferOwnership();
        } else {
            this.showErrorDialog();
        }
        this.dialogRef.close();
    }
    private navigateToTransferOwnership() {
        this.fiStateService.go(FiStateNames.OtherSettings.TransferOwnership, {
            sourceUserId: !this.data.isMultipleUsersDelete && this.data.userId,
        });
    }

    private showErrorDialog() {
        this.fiDialogsService.error({
            messageText: this.appTextService.get('error_message.no_access_to_action'),
        });
    }

    getDescriptionText(): string {
        return this.appTextService.get(
            this.data.isMultipleUsersDelete
                ? 'user.multiple_delete_confirm_dialog_message_1'
                : 'user.single_delete_confirm_dialog_message_1',
        );
    }

    getDialogTextTransferOwnershipTextStart(): string {
        return this.appTextService.get(
            this.data.isMultipleUsersDelete
                ? 'user.multiple_delete_confirm_dialog_message_2_1'
                : 'user.single_delete_confirm_dialog_message_2_1',
        );
    }

    getDialogTextTransferOwnershipTextEnd(): string {
        return this.appTextService.get(
            this.data.isMultipleUsersDelete
                ? 'user.multiple_delete_confirm_dialog_message_2_2'
                : 'user.single_delete_confirm_dialog_message_2_2',
        );
    }

    getConfirmDeleteText(): string {
        return this.appTextService.get(
            this.data.isMultipleUsersDelete
                ? 'user.multiple_delete_confirm_dialog_message_3'
                : 'user.single_delete_confirm_dialog_message_3',
        );
    }

    isYesButtonDisabled(): boolean {
        return this.confirmText !== this.appTextService.get('common.delete').toUpperCase();
    }

    private appTextService: AppTextService;
    private fiStateService: FiStateService;
    private stateAccessCheckService: StateAccessCheckService;
    private fiDialogsService: FiDialogsService;
    private setServices() {
        this.appTextService = this.injector.get(AppTextService);
        this.fiStateService = this.injector.get(FiStateService);
        this.stateAccessCheckService = this.injector.get(StateAccessCheckService);
        this.fiDialogsService = this.injector.get(FiDialogsService);
    }
}
